import { cn } from './utils'

export const composerFieldShellClassName =
  'relative flex w-full min-h-8 items-center'

export const composerFieldInsetXClassName = 'px-2'

/** Use when a leading icon button sits immediately before the field. */
export const composerFieldInsetAfterLeadingActionClassName = 'pl-0 pr-2'

/** Tight gap between a leading icon button and the composer field. */
export const composerRowLeadingActionGapClassName = 'gap-1'

/** Nudge preview text to optically align with the h-8 leading icon button. */
export const composerPreviewTextTopInsetClassName = 'pt-1.5'

export const composerTextareaClassName = cn(
  'm-0 block w-full max-h-[120px] resize-none border-0 bg-transparent py-0 text-sm leading-5 outline-none placeholder:text-muted-foreground overflow-hidden',
  composerFieldInsetXClassName,
)

/** @deprecated Use composerTextareaClassName inside composerFieldShellClassName. */
export const composerFieldClassName = cn(
  composerFieldShellClassName,
  composerTextareaClassName,
)

export function getComposerFieldClassName(_value = '') {
  return composerTextareaClassName
}

export const composerFieldWrapperClassName = 'relative min-w-0 flex-1'

export const composerActionsClassName =
  'flex shrink-0 items-center gap-1 self-start'

export const composerIconButtonClassName =
  'inline-flex h-8 w-8 shrink-0 items-center justify-center self-start rounded-md transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50'

export const composerScheduleButtonClassName =
  'inline-flex h-8 shrink-0 items-center gap-1 rounded-md px-2 text-xs leading-none transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50'

const COMPOSER_LINE_HEIGHT_PX = 20

export function resizeComposerField(target: HTMLTextAreaElement) {
  target.style.height = '0px'
  target.style.height = `${Math.max(
    COMPOSER_LINE_HEIGHT_PX,
    Math.min(target.scrollHeight, 120),
  )}px`
}

export function getComposerPreviewShellClassName(content = '') {
  return cn(
    composerFieldShellClassName,
    composerFieldInsetXClassName,
    'text-sm leading-5 text-foreground overflow-y-auto whitespace-pre-wrap',
    !content.includes('\n') && 'max-h-8',
  )
}
